<template>
  <v-dialog v-model="show" persistent max-width="450">
    <v-card>
      <v-card-title>Create customer</v-card-title>
      <v-divider/>
        <v-form v-model="valid" immediate ref="form">
          <v-container class="mt-2">
            <v-row>
              <v-col>
                <v-text-field label="Name" v-model="customer.name" :rules="[fieldRules.required,fieldRules.maxLength(100)]" outlined dense :counter="100" autofocus/>
              </v-col>
            </v-row>
            <v-row v-if="$store.getters.company.province==='BC'" dense class="mb-3">
              <v-col>
                <lookup-licensee-button :customer="customer"/>
              </v-col>
            </v-row>
            <v-row v-if="multiCurrency">
              <v-col cols="4">
                <v-autocomplete v-model="customer.currency" outlined dense label="Currency"
                                :items="currencies" item-text="code" item-value="code"/>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="7">
                <v-autocomplete v-model="customer.type" outlined dense label="Type" :items="types"/>
              </v-col>
              <v-col cols="5">
                <v-text-field v-if="customer.type!=='None'" v-model="customer.license" outlined dense label="License number" :rules="[fieldRules.maxLength(20)]" :counter="20"/>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      <v-divider/>
      <v-card-actions class="pr-6">
        <v-spacer></v-spacer>
        <v-btn plain color="primary" @click="show=false;$emit('input',false)">Cancel</v-btn>
        <v-btn color="primary" @click="create()" :loading="busy">Create</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import customerTypes from '@/mixins/customerTypes'
import LookupLicenseeButton from '@/views/provinces/BC/sales/LookupLicenseeButton'

export default {
  name: 'CustomerQuickCreate',
  mixins: [customerTypes],
  components: {LookupLicenseeButton},
	props: {
    value: {type:Boolean,required:true},
    customerType: {type:String,required:false, default:'None'},
    salesRepId: {type:String,required:false,default:''},
    defaultName: {type:String, required:false, default:''}
  },
  data() {
    return {
      valid: true,
      show: false,
      currencies: [],
      types: [],
      customer: {name:'',currency:'',active:true,billWithParent:false,
                 type:this.customerType,license:'',salesRepId:this.salesRepId},
      type: 0,
      busy: false
    }
  },
  computed: {
    multiCurrency() {
      return this.$store.getters.company.settings.multiCurrency;
    }
  },
  async created() {
    if (this.multiCurrency) {
      const results = await this.$apiCall(`query CustomerQuickCreate {
                                            company {currencies {code}}
                                          }`,
                                          {});
      if (!results.error)
        this.currencies = [{code:this.$store.getters.company.settings.homeCurrency}].concat(results.data.company.currencies);
    }
    this.types = await this.buildCustomerTypes();
  },
  watch: {
    value() {
      this.customer.name = this.defaultName;
      this.customer.currency = this.$store.getters.company.settings.homeCurrency;
      this.customer.type = this.customerType;
      this.customer.license = '';
      this.customer.salesRepId = this.salesRepId;
      this.show = this.value;
    },
    type() {
      this.customer.type = this.customerType;
    }
  },
  methods: {
    async create() {
      if (!this.$refs.form.validate()) {
        this.$store.commit('setError', {type:'warning',message:`One or more fields is missing or invalid`});
        return;
      }

      this.busy = true;
      const results = await this.$store.dispatch('customerCreate', this.customer);
      this.busy = false;
      if (!results.error) {
        this.show = false;
        this.$emit('input', false);
        this.$emit('create',results.data.customerCreate);
      }
    },
  }
}
</script>
